import nr from '@/utils/NetworldRequest'
const openNr = (new nr()).getAxios()
import data from './blackUser.json'
console.log(data)
// export default {
//     getBlackList() {
//         return openNr.get(`//afanticar-test.oss-cn-hangzhou.aliyuncs.com/aftpm/json/blackUser.json`)
//     },
// }
export default data.data